import { Component, OnInit } from '@angular/core';
import { CanonicalService } from '../../../../shared/canonical.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-rasp-in-era-of-devsecops',
  templateUrl: './rasp-in-era-of-devsecops.component.html',
  styleUrls: ['./rasp-in-era-of-devsecops.component.css']
})
export class RaspInEraOfDevsecopsComponent implements OnInit {

  heading = "Runtime Application Self-Protection (RASP) for Mobile App Security in the Era of DevSecOps";
  subheading = "";
  innerWidth:number = window.innerWidth;
  env = environment;

  constructor(private canonicalService: CanonicalService) { 
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/rasp-in-era-of-devsecops");
  }

  ngOnInit(): void {
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
